import { render, staticRenderFns } from "./NewPatrolReportPage.vue?vue&type=template&id=4723c66c"
import script from "./NewPatrolReportPage.vue?vue&type=script&lang=js"
export * from "./NewPatrolReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports